import React, { useCallback } from 'react';
import Animated from 'react-native-reanimated';
import { StyleSheet } from 'react-native';
import { rem, AppView, withAnimatedNavigationHeader, CardView, SettingsItemNavigate, } from 'design-system';
import Button, { HEIGHT } from 'design-system/Button';
import { IconSmartRule } from 'design-system/icons';
import StatusBar from 'design-system/StatusBar';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { useAppSelector } from 'store/hooks';
import IconBlock from 'design-system/icons/IconBlock';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useSmartRulesNavigation } from 'hooks/useSmartRulesNavigation';
import Squircle from 'design-system/Squircle';
import { formatPlural } from 'utils';
import useColors from 'hooks/useColors';
import Text from 'design-system/Text';
import { selectActiveSmartRules, selectInactiveSmartRules } from '../selectors';
import SmartRuleDetailsCard from '../components/SmartRuleDetailsCard';
import UpgradeToUnlockSmartRules from '../components/UpgradeToUnlockSmartRules';
import { isWeb } from '../../../constants';
const strings = {
    emptyTitle: 'No active smart rules',
    emptyTitleInactive: 'No inactive smart rules',
    emptySubtitle: 'Set one now and make Emma smarter!',
    button: 'Set a new rule',
};
const keyExtractor = (item) => item.id.toString();
const SmartRulesScreen = withAnimatedNavigationHeader(({ navigation, route, scrollHandler }) => {
    const { showInactive } = route.params || {};
    const activeRules = useAppSelector(selectActiveSmartRules);
    const inactiveRules = useAppSelector(selectInactiveSmartRules);
    const { startCreateFlow } = useSmartRulesNavigation();
    const renderItem = useCallback(({ item }) => (<SmartRuleDetailsCard isCompact onPress={() => navigation.navigateDeprecated('SmartRuleDetails', item)} item={item}/>), []);
    const colors = useColors();
    const ListEmptyComponent = () => (<CardView largePadding noMarginTop>
        <Squircle color={colors.background.dark} width={rem(72)} height={rem(72)} style={styles.icon}>
          <IconSmartRule size={rem(40)}/>
        </Squircle>
        <Text Text-16 centered style={styles.emptyTitle}>
          {showInactive ? strings.emptyTitleInactive : strings.emptyTitle}
        </Text>
        {!showInactive && (<Text TextThin-14 Secondary centered>
            {strings.emptySubtitle}
          </Text>)}
      </CardView>);
    const ListHeaderComponent = () => {
        if (showInactive)
            return null;
        return <UpgradeToUnlockSmartRules />;
    };
    const ListFooterComponent = () => {
        if (showInactive || !inactiveRules.length)
            return null;
        return (<CardView noMarginTop webPadding>
          <SettingsItemNavigate icon={<IconBlock colorKey="secondary"/>} title={formatPlural('1 inactive rule', `${inactiveRules.length} inactive rules`, inactiveRules.length)} onPress={() => navigation.push('SmartRules', { showInactive: true })}/>
        </CardView>);
    };
    const data = showInactive ? inactiveRules : activeRules;
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', HEIGHT, styles.container, paddingHorizontalStyle);
    return (<AppView withFrame={false}>
        <StatusBar barStyle="dark-content" animated/>
        <Animated.FlatList data={data} renderItem={renderItem} onScroll={scrollHandler} keyExtractor={keyExtractor} contentContainerStyle={contentContainerStyle} ListHeaderComponent={ListHeaderComponent} ListFooterComponent={ListFooterComponent} ListEmptyComponent={ListEmptyComponent}/>
        {!showInactive && (<Button brand floating title={strings.button} onPress={startCreateFlow}/>)}
      </AppView>);
}, ({ route, colors }) => ({
    title: route.params?.showInactive ? 'Inactive rules' : 'Smart rules',
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    container: {
        paddingTop: rem(16),
    },
    icon: {
        alignSelf: 'center',
    },
    emptyTitle: {
        marginTop: rem(16),
        marginBottom: rem(4),
    },
});
export default SmartRulesScreen;
